// import MISC from '@/js/miscellaneous.js'
// import PARSE from '@/js/parse.js'

const ipLoopBack = `wss://${process.env.VUE_APP_MEDIA_IP}:${process.env.VUE_APP_MEDIA_PORT}/ws`
// const ipLoopBack = `https://220.86.110.223:5001`

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    } 
    reader.onerror = error => reject(error);
  });

  async function healthCheck () {
    return new Promise((resolve) => {
      try {
        let socket = new WebSocket(ipLoopBack);
        socket.onopen = function () {
          socket.close()        
          resolve({alive:true, address: ipLoopBack})
        };
        socket.onerror = function () {
          resolve({alive:false, address: ipLoopBack})
        }
      } catch (err) {
        return {alive:false, address: ipLoopBack}
      }
    });
  }


  async function processFaceMesh (file, recog_type) {
    const base64Bytes = await toBase64(file);
  
    let promise = new Promise((resolve) => {
        let socket = new WebSocket(ipLoopBack, recog_type);
        socket.onopen = function () {
          console.log('onopen');
          let object = {date: Date.now(), recog_type: recog_type, base64: base64Bytes};
          socket.send(JSON.stringify(object));
        };
        socket.onmessage = function (event) {
          let msg = JSON.parse(event.data)
          socket.close()
          resolve(msg);          
        };
    });
  
    let pred = [];
    let msg = await promise;

    return {pred, data: msg};
  }
  
  async function processObjectDetection (file, recog_type) {
    const base64Bytes = await toBase64(file);

    let promise = new Promise((resolve) => {
        let socket = new WebSocket(ipLoopBack, recog_type+"-static");
        socket.onopen = function () {
          console.log('onopen');
          let object = {date: Date.now(), recog_type: recog_type+"-static", base64: base64Bytes};
          socket.send(JSON.stringify(object));
        };
        socket.onmessage = function (event) {
          let msg = JSON.parse(event.data)          
          console.log(msg)
          socket.close()
          resolve(msg);          
        };
    });

    let pred = [];
    let msg = await promise;
    return {pred, data: msg};
  }


  async function processIris (file, recog_type) {
    const base64Bytes = await toBase64(file);

    let promise = new Promise((resolve) => {
        let socket = new WebSocket(ipLoopBack, recog_type);
        socket.onopen = function () {
          console.log('onopen');
          let object = {date: Date.now(), recog_type: recog_type, base64: base64Bytes};
          socket.send(JSON.stringify(object));
        };
        socket.onmessage = function (event) {
          let msg = JSON.parse(event.data)          
          console.log(msg)
          socket.close()
          resolve(msg);          
        };
    });

    let pred = [];
    let msg = await promise;
    return {pred, data: msg};
  }

  async function processSelfieSegmentation (file, recog_type) {
    const base64Bytes = await toBase64(file);

    let promise = new Promise((resolve) => {
        let socket = new WebSocket(ipLoopBack, recog_type);
        socket.onopen = function () {
          console.log('onopen');
          let object = {date: Date.now(), recog_type: recog_type, base64: base64Bytes};
          socket.send(JSON.stringify(object));
        };
        socket.onmessage = function (event) {
          let msg = JSON.parse(event.data)
          socket.close()
          resolve(msg.base64);
        };
    });

    let pred = [];
    let base64_str = await promise;
    return {pred, data: {}, base64: base64_str};
  }

async function processHairSegmentation (file, recog_type) {
  const base64Bytes = await toBase64(file);

  let promise = new Promise((resolve) => {
      let socket = new WebSocket(ipLoopBack, recog_type);
      socket.onopen = function () {
        console.log('onopen');
        let object = {date: Date.now(), recog_type: recog_type, base64: base64Bytes};
        socket.send(JSON.stringify(object));
      };
      socket.onmessage = function (event) {
        let msg = JSON.parse(event.data)
        socket.close()
        resolve(msg.base64);
      };
  });

  let pred = [];
  let base64_str = await promise;
  return {pred, data: {}, base64: base64_str};
}

async function processHands (file, recog_type) {
  const base64Bytes = await toBase64(file);

  let promise = new Promise((resolve) => {
      let socket = new WebSocket(ipLoopBack, recog_type);
      socket.onopen = function () {
        console.log('onopen');
        let object = {date: Date.now(), recog_type: recog_type, base64: base64Bytes};
        socket.send(JSON.stringify(object));
      };
      socket.onmessage = function (event) {
        let msg = JSON.parse(event.data)
        socket.close()
        resolve(msg);
      };
  });

  let pred = [];
  let msg = await promise;
  return {pred, data: msg};
}


async function processPose (file, recog_type) {
  const base64Bytes = await toBase64(file);

  let promise = new Promise((resolve) => {
      let socket = new WebSocket(ipLoopBack, recog_type);
      socket.onopen = function () {
        console.log('onopen');
        let object = {date: Date.now(), recog_type: recog_type, base64: base64Bytes};
        socket.send(JSON.stringify(object));
      };
      socket.onmessage = function (event) {
        let msg = JSON.parse(event.data)        
        socket.close()
        resolve(msg);        
      };
  });

  let pred = [];
  let msg = await promise;
  return {pred, data: msg};
}

  
export default {
    healthCheck,
    processFaceMesh,
    processSelfieSegmentation,
    processHairSegmentation,
    processObjectDetection,
    processHands,
    processPose,
    processIris,
  }